import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleHelp } from '@ng-icons/lucide';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

import { AideComponent } from '../../../aide/aide.component';

@Component({
  selector: 'app-help-button',
  imports: [CdkOverlayOrigin, NgIcon, HlmButton, AideComponent, CdkConnectedOverlay, HlmTooltipImports],
  providers: [provideIcons({ lucideCircleHelp })],
  templateUrl: './help-button.component.html',
})
export class HelpButtonComponent {
  aideEstOuvert = signal<boolean>(false);

  toggleAide() {
    this.aideEstOuvert.set(!this.aideEstOuvert());
  }
}
